import _ from 'lodash';
import publicUrls from '../config/publicUrls.json';
import routeParamMappings from '../config/routeParamMappings.json';

export function getSportUrlParam(country, sport) {
  const mapping = routeParamMappings[country];
  const invertedMapping = _.invert(mapping);

  let sportParam = invertedMapping[sport];

  if (!sportParam) {
    Object.keys(mapping).forEach((key) => {
      if (typeof mapping[key] === 'object' && !mapping[key].not && mapping[key].indexOf(sport) !== -1) {
        sportParam = key;
      }
    });

    if (!sportParam) {
      sportParam = _.findKey(mapping, 'not');
    }
  }

  return sportParam;
}

export default function getArticleLink(contentContainer, options = {}) {
  if (!contentContainer) {
    throw new Error('ContentContainer required');
  }

  let country;
  if (options.country) {
    country = options.country;
  } else {
    const language = contentContainer.settings && contentContainer.settings.language ? contentContainer.settings.language : 'sv';
    if (language === 'sv') country = 'se';
    else if (language === 'da') country = 'dk';
    else country = language;
  }

  const publicUrl = options.excludeHost ? '' : publicUrls[country];

  const mapping = routeParamMappings[country];
  const invertedMapping = _.invert(mapping);

  const sportLabel = invertedMapping.sport;
  const newsLabel = invertedMapping.news;
  const podcastLabel = invertedMapping.podcasts;
  const blogLabel = invertedMapping.blogs;
  // const premiumLabel = invertedMapping.premium;

  const sport = _.get(contentContainer, 'tags.sports[0].en.slug', '');
  const blog = _.get(contentContainer, 'tags.blogs[0]', '');
  const podcast = _.get(contentContainer, 'tags.podcasts[0]', '');
  // const program = _.get(contentContainer, 'tags.programType.slug', '');

  const sportParam = getSportUrlParam(country, sport);

  let linkType = 'ArticlePage';
  let routeParams = [sportParam, contentContainer.slug];
  let href = `/${sportLabel}/${sportParam}/${newsLabel}/${contentContainer.slug}`;

  if (blog) {
    linkType = 'BlogPageWithSlug';
    routeParams = [sportParam, blog, contentContainer.id];
    href = `/${sportLabel}/${sportParam}/${blogLabel}/${blog}/${contentContainer.slug}`;
  } else if (podcast) {
    linkType = 'PodcastPageWithSlug';
    routeParams = [sportParam, podcast, contentContainer.id];
    href = `/${sportLabel}/${sportParam}/${podcastLabel}/${podcast}/${contentContainer.slug}`;
  } /* TODO uncomment when login is in place: else if (program) {
    linkType = 'LongformWithSlug';
    routeParams = [program, contentContainer.slug];
    href = `/${premiumLabel}/${program}/${contentContainer.slug}`;
  }*/

  if (!options.noHost) {
    href = `https://${publicUrl}${href}`;
  }

  if (options.href) {
    return href;
  }

  return {
    linkType: linkType,
    routeParams: routeParams,
  };
}



// WEBPACK FOOTER //
// ./src/util/getArticleLink.js